import React, { useState } from "react";
import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import "./ContactForm.css";

const contactDetails = [
  {
    icon: MapPin,
    label: "Our Store",
    lines: ["No.157 PMG Complex, South Usman Road,", "T. Nagar, Chennai 600017"],
  },
  {
    icon: Phone,
    label: "Call Us",
    lines: ["98844 42716"],
  },
  {
    icon: MessageCircle,
    label: "WhatsApp",
    lines: ["Message us anytime"],
  },
  {
    icon: Clock,
    label: "Open Hours",
    lines: ["Mon – Sat · 10:00 AM to 8:00 PM"],
  },
];

export default function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    goldType: "Jewellery",
    weight: "",
    karat: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Quote request submitted:", form);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__info">
        <span className="contact__eyebrow">
          <span className="contact__eyebrow-line" />
          Visit Us
        </span>

        <h2 className="contact__headline">
          Get your <span className="contact__highlight">instant cash</span>
          <br />
          quote.
        </h2>

        <p className="contact__subtext">
          Drop your details and our team will call you back, or simply walk
          into our T. Nagar store. We are always happy to serve you.
        </p>

        <ul className="contact__list">
          {contactDetails.map(({ icon: Icon, label, lines }) => (
            <li className="contact__item" key={label}>
              <span className="contact__item-icon">
                <Icon size={18} strokeWidth={1.75} />
              </span>
              <div>
                <p className="contact__item-label">{label}</p>
                {lines.map((line, i) => (
                  <p className="contact__item-text" key={i}>
                    {line}
                  </p>
                ))}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <form className="contact__form" onSubmit={handleSubmit}>
        <div className="contact__row">
          <div className="contact__field">
            <label className="contact__label" htmlFor="name">
              Name*
            </label>
            <input
              className="contact__input"
              id="name"
              name="name"
              type="text"
              placeholder="Your full name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact__field">
            <label className="contact__label" htmlFor="phone">
              Phone*
            </label>
            <input
              className="contact__input"
              id="phone"
              name="phone"
              type="tel"
              placeholder="98844 42716"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="contact__row">
          <div className="contact__field">
            <label className="contact__label" htmlFor="goldType">
              Gold Type
            </label>
            <select
              className="contact__input contact__select"
              id="goldType"
              name="goldType"
              value={form.goldType}
              onChange={handleChange}
            >
              <option>Jewellery</option>
              <option>Coins</option>
              <option>Bars</option>
              <option>Other</option>
            </select>
          </div>

          <div className="contact__field">
            <label className="contact__label" htmlFor="weight">
              Weight (g)
            </label>
            <input
              className="contact__input"
              id="weight"
              name="weight"
              type="number"
              placeholder="20"
              value={form.weight}
              onChange={handleChange}
            />
          </div>

          <div className="contact__field">
            <label className="contact__label" htmlFor="karat">
              Karat
            </label>
            <input
              className="contact__input"
              id="karat"
              name="karat"
              type="text"
              placeholder="22"
              value={form.karat}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="contact__field">
          <label className="contact__label" htmlFor="message">
            Message
          </label>
          <textarea
            className="contact__input contact__textarea"
            id="message"
            name="message"
            placeholder="Tell us about your gold (optional)"
            rows={3}
            value={form.message}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="contact__submit">
          Request My Quote
        </button>

        <p className="contact__footnote">
          100% safe &amp; confidential · We never share your details.
        </p>
      </form>
    </section>
  );
}
